'use client'; // Error boundaries must be Client Components

import { useEffect } from 'react';

import ErrorTemplate from '@/components/common/etc/errorTemplate';
import { notify } from '@/utils/js/notify';

export default function Error({ error, reset }: { error: any; reset: () => void }) {
  useEffect(() => {
    const errorDetails = {
      timestamp: new Date().toISOString(),
      errorType: error?.name,
      errorMessage: error?.message,
      // errorStack: error?.stack,
      // fetch 관련 추가 정보
      response: error?.response
        ? {
            status: error.response.status,
            statusText: error.response.statusText,
            url: error.response.url,
          }
        : null,
      response2: JSON.stringify(error),
      // 네트워크 상태
      online: navigator.onLine,
      // 브라우저 정보
      userAgent: navigator.userAgent,
    };

    if (
      error &&
      process.env.isProdServer === 'true' &&
      !/Googlebot|bingbot/i.test(navigator.userAgent) &&
      error?.name !== 'ChunkLoadError'
    ) {
      // notify(error as any);
      notify(
        `currentPath: ${window.location.href}`,
        `error : ${error} ${error.message} (${error.name})`,
        { ...error?.data, ...errorDetails }, // 추가 정보 포함
      );
    }
  }, [error]);

  return (
    // <div>
    //   <h2>Something went wrong!11</h2>
    //   <button
    //     onClick={
    //       // Attempt to recover by trying to re-render the segment
    //       () => reset()
    //     }
    //   >
    //     Try again
    //   </button>
    // </div>
    <>
      {process.env.isProdServer === 'false' && (
        <div>
          개발서버용 메세지 :
          <pre style={{ padding: '10px', overflow: 'auto', whiteSpace: 'normal' }}>
            {JSON.stringify(error)}
            <br />
            ||||
            {error.toString()}
          </pre>
        </div>
      )}
      <ErrorTemplate
        title="일시적인 장애로<br/>서비스와 연결되지 못했어요"
        sub="잠시 후 다시 이용해주세요"
      />
    </>
  );
}
